module.exports = __webpack_public_path__ + "img/promo-45seater02.7081fffe.jpg";